// src/components/RoleBadge.js
import { useEffect, useState } from 'react';
import { listRoles } from '../Api';
import './RoleBadge.css';

const RoleBadge = ({ roleId }) => {
  const [roleName, setRoleName] = useState('');
  const [roleColor, setRoleColor] = useState('gray');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRoleMetadata();
  }, [roleId]);

  const loadRoleMetadata = async () => {
    try {
      setLoading(true);

      // Check if we have cached role metadata
      const cachedRoles = sessionStorage.getItem('roleMetadata');
      let roles = [];

      if (cachedRoles) {
        roles = JSON.parse(cachedRoles);
      } else {
        // Fetch roles from backend
        roles = await listRoles();
        // Cache for session to avoid repeated API calls
        sessionStorage.setItem('roleMetadata', JSON.stringify(roles));
      }

      // Find the role by ID
      const role = roles.find(r => r.role_id === roleId);

      if (role) {
        setRoleName(role.name);
        setRoleColor(getRoleColor(role.name));
      } else {
        setRoleName('Unknown');
        setRoleColor('gray');
      }
    } catch (error) {
      console.error('Failed to load role metadata:', error);
      setRoleName('Unknown');
      setRoleColor('gray');
    } finally {
      setLoading(false);
    }
  };

  const getRoleColor = (name) => {
    const roleName = name.toLowerCase();

    if (roleName.includes('super admin')) return 'purple';
    if (roleName.includes('admin')) return 'blue';
    if (roleName.includes('manager')) return 'green';
    if (roleName.includes('viewer')) return 'gray';

    return 'gray'; // Default
  };

  if (loading) {
    return (
      <span className="role-badge role-badge-loading">
        Loading...
      </span>
    );
  }

  return (
    <span className={`role-badge role-badge-${roleColor}`}>
      {roleName}
    </span>
  );
};

export default RoleBadge;
